import { useParams, useSearchParams } from 'react-router-dom'
import { Box } from '@mui/material'
import ConversationView from '../components/ConversationView'

/**
 * TicketEmbedView - Minimal view for embedding conversation thread in iframe
 *
 * This component renders ONLY the conversation thread without any chrome
 * (no header, no sidebar, no input box decoration). ConversationView handles
 * all ticket data fetching and state management internally.
 *
 * Auth token setup is handled by App.jsx which wraps all routes.
 *
 * Usage: /ticketembed/:ticketId
 * Query params:
 *   readOnly=true - shows the header and hides the conversation input
 */
const TicketEmbedView = () => {
  const { ticketId } = useParams()
  const [searchParams] = useSearchParams()
  const parsedTicketId = ticketId ? parseInt(ticketId, 10) : null
  const readOnly = searchParams.get('readOnly') === 'true'

  return (
    <Box sx={{
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',
      bgcolor: 'background.default'
    }}>
      <ConversationView
        ticketId={parsedTicketId}
        embedMode={true}
        readOnly={readOnly}
      />
    </Box>
  )
}

export default TicketEmbedView
